import React from "react"
import { graphql } from "gatsby" //highlight-line
import Layout from "../components/layout"
import SEO from "../components/seo"
import StoryItem from "../components/story-item"
import BlogItem from "../components/blog-item"

export default function Stories({ data }) {
  return (
    <Layout sb={false} mt={"mt-12"}>
      <SEO title="Bedtime Stories and Fairy Tales for young children" />
      <header className="bg-white dark:bg-gray-900 dark:text-white ">
        <h1 className="text-3xl lg:text-8xl   text-gray-900 dark:text-white mb-12 text-center">
          All Bedtime Stories and Fairy Tales
        </h1>
      </header>
      <p className={"mx-auto max-w-2xl text-center text-lg pb-4 mt-4"}>
        <strong>Nighty Night Stories</strong> is a place to find kid friendly
        and modern takes on classic fairy tales. All our stories have been
        edited by our team to ensure a clean and fun place to learn and explore.
      </p>
      <p className={"mx-auto max-w-2xl text-center text-lg pb-8 mt-4"}>
        Take a quiz or share a comment to further involve your child in these
        fantastic bed time stories.
      </p>

      <div
        className={
          "border-4 border-dashed border-gray-200 rounded-lg p-8 pb-0 mb-8"
        }
      >
        <h2 className={"text-md font-bold mb-4 text-center sm:text-left"}>
          Choose A Story
        </h2>
        {data.allWpStory.nodes.map(node => (
          <StoryItem key={node.slug} post={node} />
        ))}
      </div>
    </Layout>
  )
}

export const pageQuery = graphql`
  query {
    allWpStory(sort: { fields: [title] }) {
      nodes {
        ...story
      }
    }
    allWpPost(sort: { order: DESC, fields: date }, limit: 3) {
      nodes {
        ...post
      }
      distinct(field: commentCount)
    }
  }
`
